import { useState } from "react";


export default function useMergeState($defaults:any){
    
    const [state, setState] = useState($defaults);   

    const mergeState=($state:any)=>{
        setState(($prevState:any)=>{
            return Object.assign({},$prevState,$state);
        });
    }

    return [state, mergeState, setState] as const;    
}
